export interface CategoryOption {
  id: string;
  text: string;
}

// Map of category ID to display text
export const CATEGORY_OPTIONS_MAP: Record<string, string> = {
  '60a5a91b-6b4a-485e-b610-232b423a161d':
    'Betriebs-und Geschäftsausstattung (Anlagevermögen)',
  'd0d633ec-dda7-4aa3-867c-96e7a0d97477': 'Büroeinrichtung (Anlagevermögen)',
  '1b2d76c2-23a2-48c6-a717-7f9fecf99556':
    'Geringwertige Wirtschaftsgüter (Anlagevermögen)',
  '1b029e34-70ad-4869-95da-bc9454c8650c': 'KFZ (Anlagevermögen)',
  '571e17ef-962d-4ec1-aedf-b166d876ebe1': 'Ladeneinrichtung (Anlagevermögen)',
  '4334a658-f103-4791-810e-ffa997218766': 'Lastkraftwagen (Anlagevermögen)',
  'aa2d19a0-43e7-4330-a579-75c962254546': 'Software (Anlagevermögen)',
  '281cd301-6e13-4d27-81c2-30f896e5bf1d':
    'Sonstige Transportmittel (Anlagevermögen)',
  'e82f21da-c21b-44a0-8abb-cd805b62b231':
    'Technische Anlagen und Maschinen (Anlagevermögen)',
  '121188e5-61ec-4734-bcc2-282e4340bb33': 'Werkzeuge (Anlagevermögen)',
  '90999976-9851-491a-9b68-12f4078c219c':
    'Abschluss- und Prüfungskosten (Beratung)',
  'efa85651-fd85-11e1-a21f-0800200c9a66': 'Beratung (Beratung)',
  'c5aa9395-d856-47d9-b346-27465116e584': 'Beratung §13b (Beratung)',
  '576c695a-0572-41a0-980e-20ee5279ce65': 'Beratung §13b Drittland (Beratung)',
  '2bdc3fd5-3ef3-4732-b315-4fa2c1061994': 'Buchführungskosten (Beratung)',
  'f48154a0-fd90-11e1-a21f-0800200c9a66': 'Rechtsanwalt (Beratung)',
  'f48154a1-fd90-11e1-a21f-0800200c9a66': 'Steuerberater (Beratung)',
  '934adb21-fd90-11e1-a21f-0800200c9a66':
    'Bewirtungskosten (mit Geschäftspartnern) (Beschränkt abziehbare Betriebsausgaben)',
  'be378725-ff9e-4180-b72a-2effe6493bba':
    'Bewirtungskosten (nicht abziehbar) (Beschränkt abziehbare Betriebsausgaben)',
  'efa82f4a-fd85-11e1-a21f-0800200c9a66':
    'Bewirtungskosten (nur MA) (Beschränkt abziehbare Betriebsausgaben)',
  '09b906eb-8e05-4ee7-88a5-8e49e6c4db72':
    'Geschenke (Beschränkt abziehbare Betriebsausgaben)',
  'efa85654-fd85-11e1-a21f-0800200c9a66': 'Darlehen (Darlehen)',
  '5921d421-fd91-11e1-a21f-0800200c9a66': 'Tilgung (Darlehen)',
  'eb85ea64-2097-4234-a8e3-5f28cb49f0a2': 'Tilgung Gesellschafter (Darlehen)',
  'efa82f47-fd85-11e1-a21f-0800200c9a66': 'Fahrzeugkosten (Fahrzeug)',
  '9eaf6ff7-fd89-11e1-a21f-0800200c9a66': 'Fahrzeugpflege (Fahrzeug)',
  '9eaf6ff3-fd89-11e1-a21f-0800200c9a66': 'Fahrzeugversicherungen (Fahrzeug)',
  '9eaf6ff4-fd89-11e1-a21f-0800200c9a66': 'Fremdfahrzeuge (Fahrzeug)',
  '9eaf6ff1-fd89-11e1-a21f-0800200c9a66': 'Inspektion/Reparatur (Fahrzeug)',
  '5597e22b-7ce8-4686-b15d-c2a6caa12d3b':
    'Kosten betriebl. Nutzung Fahrzeuge im Privatvermögen (Fahrzeug)',
  '9eaf6ff0-fd89-11e1-a21f-0800200c9a66': 'Kraftstoff/Ladestrom (Fahrzeug)',
  '79e1efd6-7103-46cf-99c2-0717cc60350b': 'Mautgebühren (Fahrzeug)',
  '3199b01b-3a1f-3670-9e54-f2c106441a6e':
    'Mietleasing E-Fahrzeug/Fahrrad (Fahrzeug)',
  '1e541b97-42de-4eb2-abe7-0e208cf46f38': 'Mietleasing Kfz (Fahrzeug)',
  '9eaf6ff8-fd89-11e1-a21f-0800200c9a66': 'Sonstige Fahrzeugkosten (Fahrzeug)',
  '9eaf6ff5-fd89-11e1-a21f-0800200c9a66': 'Stellplatz/Garagenmiete (Fahrzeug)',
  '5bc9acec-85af-48dd-a4c3-9ccc4ea6ac80': 'Fortbildung (Fortbildung)',
  '09e90a1b-1aad-43b8-9803-b6fadffaf193': 'Fortbildung §13b (Fortbildung)',
  '90fcbad4-d062-4877-8ca2-9b3176782f45':
    'Fortbildung §13b Drittland (Fortbildung)',
  '16d04a27-fd91-11e1-a21f-0800200c9a66': 'Seminar/Weiterbildung (Fortbildung)',
  '205cae70-fd88-11e1-a21f-0800200c9a66': 'Agenturen (Fremdleistungen)',
  '3ce7ec19-4828-4469-ac31-754a495cdbf1':
    'Bauleistungen §13b (Fremdleistungen)',
  '205cae73-fd88-11e1-a21f-0800200c9a66': 'Dienstleister (Fremdleistungen)',
  '205cae71-fd88-11e1-a21f-0800200c9a66':
    'Freelancer/Freie Mitarbeiter (Fremdleistungen)',
  'efa82f43-fd85-11e1-a21f-0800200c9a66': 'Fremdleistungen (Fremdleistungen)',
  '113476af-ac83-4bf2-941d-0daa37022945':
    'Fremdleistungen §13b (Fremdleistungen)',
  '6d49f842-54d9-4ebb-9c24-a25daac76203':
    'Fremdleistungen §13b Drittland (Fremdleistungen)',
  '205cae72-fd88-11e1-a21f-0800200c9a66': 'Subunternehmer (Fremdleistungen)',
  'f1c2c983-db43-4d91-b0b1-c9d8aa89adef':
    'Einfuhrumsatzsteuer (Gezahlte Vorsteuer)',
  '3da06950-a89f-4b3f-9932-0e627cdf6a34':
    'Gezahlte Vorsteuer (Gezahlte Vorsteuer)',
  'e9905c70-fd87-11e1-a21f-0800200c9a66':
    'Aufwandsminderungen (Material/Waren)',
  '3085632b-dd6b-4380-9425-e5821c1c9031': 'Bezugsnebenkosten (Material/Waren)',
  'dba64b05-85f7-4359-8e83-a2556a62eeac':
    'Innergemeinschaftlicher Erwerb (Material/Waren)',
  'efa82f42-fd85-11e1-a21f-0800200c9a66': 'Material/Waren (Material/Waren)',
  '97704fd4-0e83-4c5b-a09c-1b4289644d10': 'Materialeinkauf (Material/Waren)',
  '97938aa5-c5a7-4d31-bdac-a19209ba432e': 'Wareneinkauf (Material/Waren)',
  '5bcf2ff0-fd88-11e1-a21f-0800200c9a66': 'Aushilfslöhne (Personal)',
  '93793549-d846-4c55-86b8-98902a2c47f3': 'Berufsgenossenschaft (Personal)',
  'ae6837dc-fc52-41b6-9539-4912df4999f8':
    'Freiwillige steuerfreie soziale Aufwendungen (Personal)',
  '278d79f0-2d9a-4326-9ff7-28b666ae49ca': 'Gehälter (Personal)',
  '689092e1-cb82-4d93-8659-e9068cf97b78': 'Geschäftsführergehälter (Personal)',
  'a8f23059-48c2-4dc9-aeae-d5fb8438c476':
    'Geschäftsführergehälter GmbH-Gesellschafter (Personal)',
  '5bcf2ff2-fd88-11e1-a21f-0800200c9a66': 'Löhne (Personal)',
  '3cea5628-7946-47e0-a3ad-d712c4440c77': 'Löhne für Minijobs (Personal)',
  '8afe1a96-bb88-4740-922f-ac36dc897144':
    'Pauschale Steuer auf sonstige Bezüge (Personal)',
  '5bcf2ff3-fd88-11e1-a21f-0800200c9a66':
    'Pauschale Steuer für Aushilfen (Personal)',
  '7a7300b0-e588-4732-a88b-a09537bf49f4':
    'Pauschale Steuern für Gesellschafter-Geschäftsführer (Personal)',
  '48806a21-87a2-4e4c-8ced-1857100091d4':
    'Pauschale Steuern für Minijobber (Personal)',
  'efa82f44-fd85-11e1-a21f-0800200c9a66': 'Personal (Personal)',
  '5bcf2ff4-fd88-11e1-a21f-0800200c9a66': 'Prämie/Provision (Personal)',
  '5bcf2ff1-fd88-11e1-a21f-0800200c9a66': 'Sozialabgaben (Personal)',
  'ec6225a9-e6d5-40bd-89fb-0d944ea4cc98':
    'Soziale Abgaben für Minijobber (Personal)',
  '94c7de01-6898-4e2b-803a-50e442149692':
    'Vermögenswirksame Leistungen (Personal)',
  '222b6f70-fd92-11e1-a21f-0800200c9a66': 'Einkommensteuer (Privat)',
  '35bfb902-6845-45aa-8f90-747226f1e632': 'Entnahmen Kommanditisten (Privat)',
  '800030a3-b5e8-43ef-b1a1-62046d65f1a3': 'Krankheitskosten (Privat)',
  'efa85653-fd85-11e1-a21f-0800200c9a66': 'Privat (Privat)',
  '16d04a25-fd91-11e1-a21f-0800200c9a66': 'Privatentnahmen (Privat)',
  '72b9ed0d-95fa-4be7-8035-1f96d28b9725': 'Spenden (Privat)',
  '8ee022a6-6722-4d61-924c-7e50603ffd79':
    'Verrechnungskonto Gesellschafter (Privat)',
  '328a41b4-58d7-4595-8840-1b96ad398f15': 'Versicherungen (privat) (Privat)',
  'ccbd1970-fd88-11e1-a21f-0800200c9a66': 'Heizung (Raumkosten)',
  '58b6ca5f-7d9f-4d5b-805c-6b9ec9ef4347': 'Kautionen (geleistet) (Raumkosten)',
  'ccbd1972-fd88-11e1-a21f-0800200c9a66': 'Miete/Pacht (Raumkosten)',
  'ccbd1974-fd88-11e1-a21f-0800200c9a66': 'Müllgebühren (Raumkosten)',
  '2f47898b-ad5c-460b-93f2-8966c49cf6e3': 'Raumkosten (Raumkosten)',
  'd5249d11-fd90-11e1-a21f-0800200c9a66':
    'Renovierung/Instandhaltung (Raumkosten)',
  'ccbd1973-fd88-11e1-a21f-0800200c9a66': 'Strom, Wasser, Gas (Raumkosten)',
  'f9f05690-fd89-11e1-a21f-0800200c9a66':
    'Bahn-/Flugticket, Mietwagen (Reisen)',
  'f9f05691-fd89-11e1-a21f-0800200c9a66': 'Fahrtkosten (Reisen)',
  '3620798f-ae06-4492-b775-1c87eb99247c': 'Fahrtkosten MA (Reisen)',
  '4c4f9907-0379-408a-989b-22850d2fbcdc': 'Frühstück (Reisen)',
  '8c69c437-9841-4f7d-ae1c-2457cf6b0a57': 'Kilometergelderstattung MA (Reisen)',
  'f9f05692-fd89-11e1-a21f-0800200c9a66': 'Öffentliche Verkehrsmittel (Reisen)',
  'cf03a2b0-f838-474f-ac5e-67adb9b830c7': 'Reise MA (Reisen)',
  'efa82f49-fd85-11e1-a21f-0800200c9a66': 'Reisen (Reisen)',
  'f9f05693-fd89-11e1-a21f-0800200c9a66': 'Taxi (Reisen)',
  'b99b667f-bfee-41b9-8ec0-cee308bdacfd': 'Übernachtung MA (Reisen)',
  'f9f05694-fd89-11e1-a21f-0800200c9a66': 'Übernachtungskosten (Reisen)',
  '353e8c93-5f69-4476-887f-d48734ee2cc7': 'Verpflegungsmehraufw. MA (Reisen)',
  '9fb5e4b0-94ae-47f3-804f-5ed00e4aceb6':
    'Verpflegungsmehraufwendungen (Reisen)',
  '50ca159d-1155-4d9a-8f79-b013943c774e': 'Anlagen und Maschinen (Reparaturen)',
  'efa85650-fd85-11e1-a21f-0800200c9a66': 'Reparaturen (Reparaturen)',
  'd854ed5f-969a-4b5f-b13a-9679648aa988': 'Sonstige Reparaturen (Reparaturen)',
  'd5249d12-fd90-11e1-a21f-0800200c9a66': 'Wartung (Reparaturen)',
  '16d04a20-fd91-11e1-a21f-0800200c9a66': 'Anschaffungen (Sonstige Ausgaben)',
  '6a90d581-46ba-4b59-ba8f-e568a552e0c0':
    'Aufmerksamkeiten (Sonstige Ausgaben)',
  '934adb20-fd90-11e1-a21f-0800200c9a66':
    'Betriebliche Besprechungen (Sonstige Ausgaben)',
  '16d04a21-fd91-11e1-a21f-0800200c9a66': 'Bürobedarf (Sonstige Ausgaben)',
  'ea834b8c-d104-11ec-9d64-0242ac120002':
    'Grundstücksaufwendungen (betrieblich) (Sonstige Ausgaben)',
  'fb198cf9-79f2-407c-baeb-9d8aa9b98fd0':
    'Kosten der Warenabgabe (Sonstige Ausgaben)',
  'ccbd1971-fd88-11e1-a21f-0800200c9a66':
    'Leasing für Geräte (Sonstige Ausgaben)',
  'b49aae5f-4121-4262-b8bd-f49278b66423':
    'Lizenzen und Konzessionen (Sonstige Ausgaben)',
  '587c625c-2a8b-4a0e-88a7-5e058af9f7e9':
    'Lizenzen und Konzessionen §13b (Sonstige Ausgaben)',
  '6d575db0-74e8-433d-a986-27b76ea27f9e':
    'Lizenzen und Konzessionen §13b Drittland (Sonstige Ausgaben)',
  'c1d7d464-0b42-4a7e-b6af-535b2eb4a2fd': 'Mahngebühren (Sonstige Ausgaben)',
  '16d04a24-fd91-11e1-a21f-0800200c9a66': 'Porto (Sonstige Ausgaben)',
  '16d04a26-fd91-11e1-a21f-0800200c9a66':
    'Reinigung/Reinigungsmittel (Sonstige Ausgaben)',
  '61b6c617-d5b6-44ee-b43a-ac97b71f1bd8':
    'Rundungsdifferenzen (Sonstige Ausgaben)',
  '0af461af-02f2-7a3c-4274-dc8c9ba8f013': 'Sachzuwendungen (Sonstige Ausgaben)',
  'f13b89bc-d104-11ec-9d64-0242ac120002':
    'Sonstige Abgaben (Sonstige Ausgaben)',
  '16d04a28-fd91-11e1-a21f-0800200c9a66':
    'Sonstige Ausgaben (Sonstige Ausgaben)',
  '26e4fa58-db12-443f-9e70-9a8081730c1c':
    'Verpackungsmaterial (Sonstige Ausgaben)',
  '207833b2-59fb-4185-b7b3-52ab9b944d59':
    'Währungsumrechnung (Sonstige Ausgaben)',
  '9d92c0dc-8cea-4791-ab3b-90f913101d32':
    'Wartungskosten für Hard- und Software (Sonstige Ausgaben)',
  'd5249d10-fd90-11e1-a21f-0800200c9a66':
    'Werkzeuge und Kleingeräte (Sonstige Ausgaben)',
  '16d04a29-fd91-11e1-a21f-0800200c9a66':
    'Zeitschriften/Bücher (Sonstige Ausgaben)',
  '222b6f71-fd92-11e1-a21f-0800200c9a66': 'Gewerbesteuer (Steuern)',
  '9eaf6ff2-fd89-11e1-a21f-0800200c9a66': 'KFZ-Steuer (Steuern)',
  '75c4dd86-9977-4624-bac8-620e7aa08dd2': 'Körperschaftsteuer (Steuern)',
  'fcac6066-8597-4086-8544-b95c444738a2': 'Solidaritätszuschlag (Steuern)',
  'b3a1f840-fd90-11e1-a21f-0800200c9a66': 'Festnetz (Telekommunikation)',
  'b3a1f841-fd90-11e1-a21f-0800200c9a66': 'Internet (Telekommunikation)',
  'b3a1f842-fd90-11e1-a21f-0800200c9a66': 'Mobil (Telekommunikation)',
  'efa82f4b-fd85-11e1-a21f-0800200c9a66':
    'Telekommunikation (Telekommunikation)',
  'e68b1ec8-3a46-4100-890b-01bc86cf8ada':
    'Sondervorauszahlung 1/11 (Umsatzsteuer-Vorauszahlungen)',
  '222b6f72-fd92-11e1-a21f-0800200c9a66':
    'Umsatzsteuer-Vorauszahlungen (Umsatzsteuer-Vorauszahlungen)',
  'ebbdd0f4-3bd4-4d2e-847f-8b68314f7ef6':
    'Umsatzsteuer-Vorjahr (Umsatzsteuer-Vorauszahlungen)',
  'd6472ace-832b-4c74-b136-5ceff39fdfa1':
    'Umsatzsteuerzahlung für EU-Länder (Umsatzsteuer-Vorauszahlungen)',
  'f49d88d1-fd88-11e1-a21f-0800200c9a66':
    'Beiträge (Versicherungen (betrieblich))',
  'f49d88d0-fd88-11e1-a21f-0800200c9a66':
    'Betriebshaftpflicht (Versicherungen (betrieblich))',
  '5ce0f8a0-fd89-11e1-a21f-0800200c9a66':
    'Firmenversicherung (Versicherungen (betrieblich))',
  'f49d88d2-fd88-11e1-a21f-0800200c9a66':
    'Rechtschutz (Versicherungen (betrieblich))',
  'f49d88d3-fd88-11e1-a21f-0800200c9a66':
    'Transportversicherung (Versicherungen (betrieblich))',
  'efa82f46-fd85-11e1-a21f-0800200c9a66':
    'Versicherungen (betrieblich) (Versicherungen (betrieblich))',
  'd22989b0-fd89-11e1-a21f-0800200c9a66':
    'Anzeigen Print- und Online (Werbung)',
  'd22989b1-fd89-11e1-a21f-0800200c9a66': 'Dekoration (Werbung)',
  'd22989b2-fd89-11e1-a21f-0800200c9a66':
    'Geschäftspapier/Visitenkarten (Werbung)',
  'd22989b3-fd89-11e1-a21f-0800200c9a66': 'Marketing (Werbung)',
  'd22989b4-fd89-11e1-a21f-0800200c9a66': 'Messekosten (Werbung)',
  '01d94be1-ba15-4dd8-a8e2-e1d51eaab8f9': 'Repräsentationskosten (Werbung)',
  'f57c7c2a-d104-11ec-9d64-0242ac120002': 'Streuartikel (Werbung)',
  'd22989b5-fd89-11e1-a21f-0800200c9a66': 'Werbegeschenke/Sponsoring (Werbung)',
  'efa82f48-fd85-11e1-a21f-0800200c9a66': 'Werbung (Werbung)',
  '00d8f5f6-1d8a-40da-96ee-c53b25f37503': 'Werbung §13b (Werbung)',
  'db55a5ca-8b9e-4c84-9961-dd2110f3b2b6': 'Werbung §13b Drittland (Werbung)',
  '5921d422-fd91-11e1-a21f-0800200c9a66': 'Darlehensgebühren (Zinsen/Gebühren)',
  '5921d420-fd91-11e1-a21f-0800200c9a66': 'Darlehenszinsen (Zinsen/Gebühren)',
  '16d04a22-fd91-11e1-a21f-0800200c9a66': 'Girokontozinsen (Zinsen/Gebühren)',
  '16d04a23-fd91-11e1-a21f-0800200c9a66':
    'Kontoführung/Kartengebühr (Zinsen/Gebühren)',
  'c3dc62f5-e382-4f34-a286-b06bda0b5e90': 'Zinsen/Gebühren (Zinsen/Gebühren)',
  '62e21a0d-af46-4674-bfa0-60bc2607fa17': 'Durchlaufende Posten (Zu prüfen)',
  'dd56efd2-6c62-40e4-9d9e-cba7b0045911': 'Geldtransit (Zu prüfen)',
  '8d2e71c6-09d5-439a-a295-a9e71661afcd': 'Zu prüfen (Zu prüfen)',
  '4708d50c-f3a9-4a27-98c4-d37502e3b45c': 'Lohn-und Kirchensteuer (Zu zahlen)',
  'cd3ea3e5-b681-496b-9886-7f8a8ab0397a': 'Nettogehälter (Zu zahlen)',
  '27c9577e-9472-47cd-818e-a0cbb042bf82':
    'Sozialversicherungsbeiträge (Zu zahlen)',
  '4abd3f74-6556-48df-9581-91c689b0572f':
    'Verbindlichkeiten für Einbehaltungen von Mitarbeitern (Zu zahlen)',
  'db9689f7-49d6-4f6f-9cc4-93804f7c674a': 'Vermögensbildung (Zu zahlen)',
  'fa4aadaa-8f1f-4121-99b4-bac9ad7c9bc9': 'Verrechnung Lohn/Gehalt (Zu zahlen)',
  'ec472a04-9712-4ebb-9c8d-981941a456e5': 'Zu zahlen (Zu zahlen)',
};

// Array of all categories for dropdown
export const CATEGORY_OPTIONS: CategoryOption[] = [
  {
    id: '60a5a91b-6b4a-485e-b610-232b423a161d',
    text: 'Betriebs-und Geschäftsausstattung (Anlagevermögen)',
  },
  {
    id: 'd0d633ec-dda7-4aa3-867c-96e7a0d97477',
    text: 'Büroeinrichtung (Anlagevermögen)',
  },
  {
    id: '1b2d76c2-23a2-48c6-a717-7f9fecf99556',
    text: 'Geringwertige Wirtschaftsgüter (Anlagevermögen)',
  },
  { id: '1b029e34-70ad-4869-95da-bc9454c8650c', text: 'KFZ (Anlagevermögen)' },
  {
    id: '571e17ef-962d-4ec1-aedf-b166d876ebe1',
    text: 'Ladeneinrichtung (Anlagevermögen)',
  },
  {
    id: '4334a658-f103-4791-810e-ffa997218766',
    text: 'Lastkraftwagen (Anlagevermögen)',
  },
  {
    id: 'aa2d19a0-43e7-4330-a579-75c962254546',
    text: 'Software (Anlagevermögen)',
  },
  {
    id: '281cd301-6e13-4d27-81c2-30f896e5bf1d',
    text: 'Sonstige Transportmittel (Anlagevermögen)',
  },
  {
    id: 'e82f21da-c21b-44a0-8abb-cd805b62b231',
    text: 'Technische Anlagen und Maschinen (Anlagevermögen)',
  },
  {
    id: '121188e5-61ec-4734-bcc2-282e4340bb33',
    text: 'Werkzeuge (Anlagevermögen)',
  },
  {
    id: '90999976-9851-491a-9b68-12f4078c219c',
    text: 'Abschluss- und Prüfungskosten (Beratung)',
  },
  { id: 'efa85651-fd85-11e1-a21f-0800200c9a66', text: 'Beratung (Beratung)' },
  {
    id: 'c5aa9395-d856-47d9-b346-27465116e584',
    text: 'Beratung §13b (Beratung)',
  },
  {
    id: '576c695a-0572-41a0-980e-20ee5279ce65',
    text: 'Beratung §13b Drittland (Beratung)',
  },
  {
    id: '2bdc3fd5-3ef3-4732-b315-4fa2c1061994',
    text: 'Buchführungskosten (Beratung)',
  },
  {
    id: 'f48154a0-fd90-11e1-a21f-0800200c9a66',
    text: 'Rechtsanwalt (Beratung)',
  },
  {
    id: 'f48154a1-fd90-11e1-a21f-0800200c9a66',
    text: 'Steuerberater (Beratung)',
  },
  {
    id: '934adb21-fd90-11e1-a21f-0800200c9a66',
    text: 'Bewirtungskosten (mit Geschäftspartnern) (Beschränkt abziehbare Betriebsausgaben)',
  },
  {
    id: 'be378725-ff9e-4180-b72a-2effe6493bba',
    text: 'Bewirtungskosten (nicht abziehbar) (Beschränkt abziehbare Betriebsausgaben)',
  },
  {
    id: 'efa82f4a-fd85-11e1-a21f-0800200c9a66',
    text: 'Bewirtungskosten (nur MA) (Beschränkt abziehbare Betriebsausgaben)',
  },
  {
    id: '09b906eb-8e05-4ee7-88a5-8e49e6c4db72',
    text: 'Geschenke (Beschränkt abziehbare Betriebsausgaben)',
  },
  { id: 'efa85654-fd85-11e1-a21f-0800200c9a66', text: 'Darlehen (Darlehen)' },
  { id: '5921d421-fd91-11e1-a21f-0800200c9a66', text: 'Tilgung (Darlehen)' },
  {
    id: 'eb85ea64-2097-4234-a8e3-5f28cb49f0a2',
    text: 'Tilgung Gesellschafter (Darlehen)',
  },
  {
    id: 'efa82f47-fd85-11e1-a21f-0800200c9a66',
    text: 'Fahrzeugkosten (Fahrzeug)',
  },
  {
    id: '9eaf6ff7-fd89-11e1-a21f-0800200c9a66',
    text: 'Fahrzeugpflege (Fahrzeug)',
  },
  {
    id: '9eaf6ff3-fd89-11e1-a21f-0800200c9a66',
    text: 'Fahrzeugversicherungen (Fahrzeug)',
  },
  {
    id: '9eaf6ff4-fd89-11e1-a21f-0800200c9a66',
    text: 'Fremdfahrzeuge (Fahrzeug)',
  },
  {
    id: '9eaf6ff1-fd89-11e1-a21f-0800200c9a66',
    text: 'Inspektion/Reparatur (Fahrzeug)',
  },
  {
    id: '5597e22b-7ce8-4686-b15d-c2a6caa12d3b',
    text: 'Kosten betriebl. Nutzung Fahrzeuge im Privatvermögen (Fahrzeug)',
  },
  {
    id: '9eaf6ff0-fd89-11e1-a21f-0800200c9a66',
    text: 'Kraftstoff/Ladestrom (Fahrzeug)',
  },
  {
    id: '79e1efd6-7103-46cf-99c2-0717cc60350b',
    text: 'Mautgebühren (Fahrzeug)',
  },
  {
    id: '3199b01b-3a1f-3670-9e54-f2c106441a6e',
    text: 'Mietleasing E-Fahrzeug/Fahrrad (Fahrzeug)',
  },
  {
    id: '1e541b97-42de-4eb2-abe7-0e208cf46f38',
    text: 'Mietleasing Kfz (Fahrzeug)',
  },
  {
    id: '9eaf6ff8-fd89-11e1-a21f-0800200c9a66',
    text: 'Sonstige Fahrzeugkosten (Fahrzeug)',
  },
  {
    id: '9eaf6ff5-fd89-11e1-a21f-0800200c9a66',
    text: 'Stellplatz/Garagenmiete (Fahrzeug)',
  },
  {
    id: '5bc9acec-85af-48dd-a4c3-9ccc4ea6ac80',
    text: 'Fortbildung (Fortbildung)',
  },
  {
    id: '09e90a1b-1aad-43b8-9803-b6fadffaf193',
    text: 'Fortbildung §13b (Fortbildung)',
  },
  {
    id: '90fcbad4-d062-4877-8ca2-9b3176782f45',
    text: 'Fortbildung §13b Drittland (Fortbildung)',
  },
  {
    id: '16d04a27-fd91-11e1-a21f-0800200c9a66',
    text: 'Seminar/Weiterbildung (Fortbildung)',
  },
  {
    id: '205cae70-fd88-11e1-a21f-0800200c9a66',
    text: 'Agenturen (Fremdleistungen)',
  },
  {
    id: '3ce7ec19-4828-4469-ac31-754a495cdbf1',
    text: 'Bauleistungen §13b (Fremdleistungen)',
  },
  {
    id: '205cae73-fd88-11e1-a21f-0800200c9a66',
    text: 'Dienstleister (Fremdleistungen)',
  },
  {
    id: '205cae71-fd88-11e1-a21f-0800200c9a66',
    text: 'Freelancer/Freie Mitarbeiter (Fremdleistungen)',
  },
  {
    id: 'efa82f43-fd85-11e1-a21f-0800200c9a66',
    text: 'Fremdleistungen (Fremdleistungen)',
  },
  {
    id: '113476af-ac83-4bf2-941d-0daa37022945',
    text: 'Fremdleistungen §13b (Fremdleistungen)',
  },
  {
    id: '6d49f842-54d9-4ebb-9c24-a25daac76203',
    text: 'Fremdleistungen §13b Drittland (Fremdleistungen)',
  },
  {
    id: '205cae72-fd88-11e1-a21f-0800200c9a66',
    text: 'Subunternehmer (Fremdleistungen)',
  },
  {
    id: 'f1c2c983-db43-4d91-b0b1-c9d8aa89adef',
    text: 'Einfuhrumsatzsteuer (Gezahlte Vorsteuer)',
  },
  {
    id: '3da06950-a89f-4b3f-9932-0e627cdf6a34',
    text: 'Gezahlte Vorsteuer (Gezahlte Vorsteuer)',
  },
  {
    id: 'e9905c70-fd87-11e1-a21f-0800200c9a66',
    text: 'Aufwandsminderungen (Material/Waren)',
  },
  {
    id: '3085632b-dd6b-4380-9425-e5821c1c9031',
    text: 'Bezugsnebenkosten (Material/Waren)',
  },
  {
    id: 'dba64b05-85f7-4359-8e83-a2556a62eeac',
    text: 'Innergemeinschaftlicher Erwerb (Material/Waren)',
  },
  {
    id: 'efa82f42-fd85-11e1-a21f-0800200c9a66',
    text: 'Material/Waren (Material/Waren)',
  },
  {
    id: '97704fd4-0e83-4c5b-a09c-1b4289644d10',
    text: 'Materialeinkauf (Material/Waren)',
  },
  {
    id: '97938aa5-c5a7-4d31-bdac-a19209ba432e',
    text: 'Wareneinkauf (Material/Waren)',
  },
  {
    id: '5bcf2ff0-fd88-11e1-a21f-0800200c9a66',
    text: 'Aushilfslöhne (Personal)',
  },
  {
    id: '93793549-d846-4c55-86b8-98902a2c47f3',
    text: 'Berufsgenossenschaft (Personal)',
  },
  {
    id: 'ae6837dc-fc52-41b6-9539-4912df4999f8',
    text: 'Freiwillige steuerfreie soziale Aufwendungen (Personal)',
  },
  { id: '278d79f0-2d9a-4326-9ff7-28b666ae49ca', text: 'Gehälter (Personal)' },
  {
    id: '689092e1-cb82-4d93-8659-e9068cf97b78',
    text: 'Geschäftsführergehälter (Personal)',
  },
  {
    id: 'a8f23059-48c2-4dc9-aeae-d5fb8438c476',
    text: 'Geschäftsführergehälter GmbH-Gesellschafter (Personal)',
  },
  { id: '5bcf2ff2-fd88-11e1-a21f-0800200c9a66', text: 'Löhne (Personal)' },
  {
    id: '3cea5628-7946-47e0-a3ad-d712c4440c77',
    text: 'Löhne für Minijobs (Personal)',
  },
  {
    id: '8afe1a96-bb88-4740-922f-ac36dc897144',
    text: 'Pauschale Steuer auf sonstige Bezüge (Personal)',
  },
  {
    id: '5bcf2ff3-fd88-11e1-a21f-0800200c9a66',
    text: 'Pauschale Steuer für Aushilfen (Personal)',
  },
  {
    id: '7a7300b0-e588-4732-a88b-a09537bf49f4',
    text: 'Pauschale Steuern für Gesellschafter-Geschäftsführer (Personal)',
  },
  {
    id: '48806a21-87a2-4e4c-8ced-1857100091d4',
    text: 'Pauschale Steuern für Minijobber (Personal)',
  },
  { id: 'efa82f44-fd85-11e1-a21f-0800200c9a66', text: 'Personal (Personal)' },
  {
    id: '5bcf2ff4-fd88-11e1-a21f-0800200c9a66',
    text: 'Prämie/Provision (Personal)',
  },
  {
    id: '5bcf2ff1-fd88-11e1-a21f-0800200c9a66',
    text: 'Sozialabgaben (Personal)',
  },
  {
    id: 'ec6225a9-e6d5-40bd-89fb-0d944ea4cc98',
    text: 'Soziale Abgaben für Minijobber (Personal)',
  },
  {
    id: '94c7de01-6898-4e2b-803a-50e442149692',
    text: 'Vermögenswirksame Leistungen (Personal)',
  },
  {
    id: '222b6f70-fd92-11e1-a21f-0800200c9a66',
    text: 'Einkommensteuer (Privat)',
  },
  {
    id: '35bfb902-6845-45aa-8f90-747226f1e632',
    text: 'Entnahmen Kommanditisten (Privat)',
  },
  {
    id: '800030a3-b5e8-43ef-b1a1-62046d65f1a3',
    text: 'Krankheitskosten (Privat)',
  },
  { id: 'efa85653-fd85-11e1-a21f-0800200c9a66', text: 'Privat (Privat)' },
  {
    id: '16d04a25-fd91-11e1-a21f-0800200c9a66',
    text: 'Privatentnahmen (Privat)',
  },
  { id: '72b9ed0d-95fa-4be7-8035-1f96d28b9725', text: 'Spenden (Privat)' },
  {
    id: '8ee022a6-6722-4d61-924c-7e50603ffd79',
    text: 'Verrechnungskonto Gesellschafter (Privat)',
  },
  {
    id: '328a41b4-58d7-4595-8840-1b96ad398f15',
    text: 'Versicherungen (privat) (Privat)',
  },
  { id: 'ccbd1970-fd88-11e1-a21f-0800200c9a66', text: 'Heizung (Raumkosten)' },
  {
    id: '58b6ca5f-7d9f-4d5b-805c-6b9ec9ef4347',
    text: 'Kautionen (geleistet) (Raumkosten)',
  },
  {
    id: 'ccbd1972-fd88-11e1-a21f-0800200c9a66',
    text: 'Miete/Pacht (Raumkosten)',
  },
  {
    id: 'ccbd1974-fd88-11e1-a21f-0800200c9a66',
    text: 'Müllgebühren (Raumkosten)',
  },
  {
    id: '2f47898b-ad5c-460b-93f2-8966c49cf6e3',
    text: 'Raumkosten (Raumkosten)',
  },
  {
    id: 'd5249d11-fd90-11e1-a21f-0800200c9a66',
    text: 'Renovierung/Instandhaltung (Raumkosten)',
  },
  {
    id: 'ccbd1973-fd88-11e1-a21f-0800200c9a66',
    text: 'Strom, Wasser, Gas (Raumkosten)',
  },
  {
    id: 'f9f05690-fd89-11e1-a21f-0800200c9a66',
    text: 'Bahn-/Flugticket, Mietwagen (Reisen)',
  },
  { id: 'f9f05691-fd89-11e1-a21f-0800200c9a66', text: 'Fahrtkosten (Reisen)' },
  {
    id: '3620798f-ae06-4492-b775-1c87eb99247c',
    text: 'Fahrtkosten MA (Reisen)',
  },
  { id: '4c4f9907-0379-408a-989b-22850d2fbcdc', text: 'Frühstück (Reisen)' },
  {
    id: '8c69c437-9841-4f7d-ae1c-2457cf6b0a57',
    text: 'Kilometergelderstattung MA (Reisen)',
  },
  {
    id: 'f9f05692-fd89-11e1-a21f-0800200c9a66',
    text: 'Öffentliche Verkehrsmittel (Reisen)',
  },
  { id: 'cf03a2b0-f838-474f-ac5e-67adb9b830c7', text: 'Reise MA (Reisen)' },
  { id: 'efa82f49-fd85-11e1-a21f-0800200c9a66', text: 'Reisen (Reisen)' },
  { id: 'f9f05693-fd89-11e1-a21f-0800200c9a66', text: 'Taxi (Reisen)' },
  {
    id: 'b99b667f-bfee-41b9-8ec0-cee308bdacfd',
    text: 'Übernachtung MA (Reisen)',
  },
  {
    id: 'f9f05694-fd89-11e1-a21f-0800200c9a66',
    text: 'Übernachtungskosten (Reisen)',
  },
  {
    id: '353e8c93-5f69-4476-887f-d48734ee2cc7',
    text: 'Verpflegungsmehraufw. MA (Reisen)',
  },
  {
    id: '9fb5e4b0-94ae-47f3-804f-5ed00e4aceb6',
    text: 'Verpflegungsmehraufwendungen (Reisen)',
  },
  {
    id: '50ca159d-1155-4d9a-8f79-b013943c774e',
    text: 'Anlagen und Maschinen (Reparaturen)',
  },
  {
    id: 'efa85650-fd85-11e1-a21f-0800200c9a66',
    text: 'Reparaturen (Reparaturen)',
  },
  {
    id: 'd854ed5f-969a-4b5f-b13a-9679648aa988',
    text: 'Sonstige Reparaturen (Reparaturen)',
  },
  { id: 'd5249d12-fd90-11e1-a21f-0800200c9a66', text: 'Wartung (Reparaturen)' },
  {
    id: '16d04a20-fd91-11e1-a21f-0800200c9a66',
    text: 'Anschaffungen (Sonstige Ausgaben)',
  },
  {
    id: '6a90d581-46ba-4b59-ba8f-e568a552e0c0',
    text: 'Aufmerksamkeiten (Sonstige Ausgaben)',
  },
  {
    id: '934adb20-fd90-11e1-a21f-0800200c9a66',
    text: 'Betriebliche Besprechungen (Sonstige Ausgaben)',
  },
  {
    id: '16d04a21-fd91-11e1-a21f-0800200c9a66',
    text: 'Bürobedarf (Sonstige Ausgaben)',
  },
  {
    id: 'ea834b8c-d104-11ec-9d64-0242ac120002',
    text: 'Grundstücksaufwendungen (betrieblich) (Sonstige Ausgaben)',
  },
  {
    id: 'fb198cf9-79f2-407c-baeb-9d8aa9b98fd0',
    text: 'Kosten der Warenabgabe (Sonstige Ausgaben)',
  },
  {
    id: 'ccbd1971-fd88-11e1-a21f-0800200c9a66',
    text: 'Leasing für Geräte (Sonstige Ausgaben)',
  },
  {
    id: 'b49aae5f-4121-4262-b8bd-f49278b66423',
    text: 'Lizenzen und Konzessionen (Sonstige Ausgaben)',
  },
  {
    id: '587c625c-2a8b-4a0e-88a7-5e058af9f7e9',
    text: 'Lizenzen und Konzessionen §13b (Sonstige Ausgaben)',
  },
  {
    id: '6d575db0-74e8-433d-a986-27b76ea27f9e',
    text: 'Lizenzen und Konzessionen §13b Drittland (Sonstige Ausgaben)',
  },
  {
    id: 'c1d7d464-0b42-4a7e-b6af-535b2eb4a2fd',
    text: 'Mahngebühren (Sonstige Ausgaben)',
  },
  {
    id: '16d04a24-fd91-11e1-a21f-0800200c9a66',
    text: 'Porto (Sonstige Ausgaben)',
  },
  {
    id: '16d04a26-fd91-11e1-a21f-0800200c9a66',
    text: 'Reinigung/Reinigungsmittel (Sonstige Ausgaben)',
  },
  {
    id: '61b6c617-d5b6-44ee-b43a-ac97b71f1bd8',
    text: 'Rundungsdifferenzen (Sonstige Ausgaben)',
  },
  {
    id: '0af461af-02f2-7a3c-4274-dc8c9ba8f013',
    text: 'Sachzuwendungen (Sonstige Ausgaben)',
  },
  {
    id: 'f13b89bc-d104-11ec-9d64-0242ac120002',
    text: 'Sonstige Abgaben (Sonstige Ausgaben)',
  },
  {
    id: '16d04a28-fd91-11e1-a21f-0800200c9a66',
    text: 'Sonstige Ausgaben (Sonstige Ausgaben)',
  },
  {
    id: '26e4fa58-db12-443f-9e70-9a8081730c1c',
    text: 'Verpackungsmaterial (Sonstige Ausgaben)',
  },
  {
    id: '207833b2-59fb-4185-b7b3-52ab9b944d59',
    text: 'Währungsumrechnung (Sonstige Ausgaben)',
  },
  {
    id: '9d92c0dc-8cea-4791-ab3b-90f913101d32',
    text: 'Wartungskosten für Hard- und Software (Sonstige Ausgaben)',
  },
  {
    id: 'd5249d10-fd90-11e1-a21f-0800200c9a66',
    text: 'Werkzeuge und Kleingeräte (Sonstige Ausgaben)',
  },
  {
    id: '16d04a29-fd91-11e1-a21f-0800200c9a66',
    text: 'Zeitschriften/Bücher (Sonstige Ausgaben)',
  },
  {
    id: '222b6f71-fd92-11e1-a21f-0800200c9a66',
    text: 'Gewerbesteuer (Steuern)',
  },
  { id: '9eaf6ff2-fd89-11e1-a21f-0800200c9a66', text: 'KFZ-Steuer (Steuern)' },
  {
    id: '75c4dd86-9977-4624-bac8-620e7aa08dd2',
    text: 'Körperschaftsteuer (Steuern)',
  },
  {
    id: 'fcac6066-8597-4086-8544-b95c444738a2',
    text: 'Solidaritätszuschlag (Steuern)',
  },
  {
    id: 'b3a1f840-fd90-11e1-a21f-0800200c9a66',
    text: 'Festnetz (Telekommunikation)',
  },
  {
    id: 'b3a1f841-fd90-11e1-a21f-0800200c9a66',
    text: 'Internet (Telekommunikation)',
  },
  {
    id: 'b3a1f842-fd90-11e1-a21f-0800200c9a66',
    text: 'Mobil (Telekommunikation)',
  },
  {
    id: 'efa82f4b-fd85-11e1-a21f-0800200c9a66',
    text: 'Telekommunikation (Telekommunikation)',
  },
  {
    id: 'e68b1ec8-3a46-4100-890b-01bc86cf8ada',
    text: 'Sondervorauszahlung 1/11 (Umsatzsteuer-Vorauszahlungen)',
  },
  {
    id: '222b6f72-fd92-11e1-a21f-0800200c9a66',
    text: 'Umsatzsteuer-Vorauszahlungen (Umsatzsteuer-Vorauszahlungen)',
  },
  {
    id: 'ebbdd0f4-3bd4-4d2e-847f-8b68314f7ef6',
    text: 'Umsatzsteuer-Vorjahr (Umsatzsteuer-Vorauszahlungen)',
  },
  {
    id: 'd6472ace-832b-4c74-b136-5ceff39fdfa1',
    text: 'Umsatzsteuerzahlung für EU-Länder (Umsatzsteuer-Vorauszahlungen)',
  },
  {
    id: 'f49d88d1-fd88-11e1-a21f-0800200c9a66',
    text: 'Beiträge (Versicherungen (betrieblich))',
  },
  {
    id: 'f49d88d0-fd88-11e1-a21f-0800200c9a66',
    text: 'Betriebshaftpflicht (Versicherungen (betrieblich))',
  },
  {
    id: '5ce0f8a0-fd89-11e1-a21f-0800200c9a66',
    text: 'Firmenversicherung (Versicherungen (betrieblich))',
  },
  {
    id: 'f49d88d2-fd88-11e1-a21f-0800200c9a66',
    text: 'Rechtschutz (Versicherungen (betrieblich))',
  },
  {
    id: 'f49d88d3-fd88-11e1-a21f-0800200c9a66',
    text: 'Transportversicherung (Versicherungen (betrieblich))',
  },
  {
    id: 'efa82f46-fd85-11e1-a21f-0800200c9a66',
    text: 'Versicherungen (betrieblich) (Versicherungen (betrieblich))',
  },
  {
    id: 'd22989b0-fd89-11e1-a21f-0800200c9a66',
    text: 'Anzeigen Print- und Online (Werbung)',
  },
  { id: 'd22989b1-fd89-11e1-a21f-0800200c9a66', text: 'Dekoration (Werbung)' },
  {
    id: 'd22989b2-fd89-11e1-a21f-0800200c9a66',
    text: 'Geschäftspapier/Visitenkarten (Werbung)',
  },
  { id: 'd22989b3-fd89-11e1-a21f-0800200c9a66', text: 'Marketing (Werbung)' },
  { id: 'd22989b4-fd89-11e1-a21f-0800200c9a66', text: 'Messekosten (Werbung)' },
  {
    id: '01d94be1-ba15-4dd8-a8e2-e1d51eaab8f9',
    text: 'Repräsentationskosten (Werbung)',
  },
  {
    id: 'f57c7c2a-d104-11ec-9d64-0242ac120002',
    text: 'Streuartikel (Werbung)',
  },
  {
    id: 'd22989b5-fd89-11e1-a21f-0800200c9a66',
    text: 'Werbegeschenke/Sponsoring (Werbung)',
  },
  { id: 'efa82f48-fd85-11e1-a21f-0800200c9a66', text: 'Werbung (Werbung)' },
  {
    id: '00d8f5f6-1d8a-40da-96ee-c53b25f37503',
    text: 'Werbung §13b (Werbung)',
  },
  {
    id: 'db55a5ca-8b9e-4c84-9961-dd2110f3b2b6',
    text: 'Werbung §13b Drittland (Werbung)',
  },
  {
    id: '5921d422-fd91-11e1-a21f-0800200c9a66',
    text: 'Darlehensgebühren (Zinsen/Gebühren)',
  },
  {
    id: '5921d420-fd91-11e1-a21f-0800200c9a66',
    text: 'Darlehenszinsen (Zinsen/Gebühren)',
  },
  {
    id: '16d04a22-fd91-11e1-a21f-0800200c9a66',
    text: 'Girokontozinsen (Zinsen/Gebühren)',
  },
  {
    id: '16d04a23-fd91-11e1-a21f-0800200c9a66',
    text: 'Kontoführung/Kartengebühr (Zinsen/Gebühren)',
  },
  {
    id: 'c3dc62f5-e382-4f34-a286-b06bda0b5e90',
    text: 'Zinsen/Gebühren (Zinsen/Gebühren)',
  },
  {
    id: '62e21a0d-af46-4674-bfa0-60bc2607fa17',
    text: 'Durchlaufende Posten (Zu prüfen)',
  },
  {
    id: 'dd56efd2-6c62-40e4-9d9e-cba7b0045911',
    text: 'Geldtransit (Zu prüfen)',
  },
  { id: '8d2e71c6-09d5-439a-a295-a9e71661afcd', text: 'Zu prüfen (Zu prüfen)' },
  {
    id: '4708d50c-f3a9-4a27-98c4-d37502e3b45c',
    text: 'Lohn-und Kirchensteuer (Zu zahlen)',
  },
  {
    id: 'cd3ea3e5-b681-496b-9886-7f8a8ab0397a',
    text: 'Nettogehälter (Zu zahlen)',
  },
  {
    id: '27c9577e-9472-47cd-818e-a0cbb042bf82',
    text: 'Sozialversicherungsbeiträge (Zu zahlen)',
  },
  {
    id: '4abd3f74-6556-48df-9581-91c689b0572f',
    text: 'Verbindlichkeiten für Einbehaltungen von Mitarbeitern (Zu zahlen)',
  },
  {
    id: 'db9689f7-49d6-4f6f-9cc4-93804f7c674a',
    text: 'Vermögensbildung (Zu zahlen)',
  },
  {
    id: 'fa4aadaa-8f1f-4121-99b4-bac9ad7c9bc9',
    text: 'Verrechnung Lohn/Gehalt (Zu zahlen)',
  },
  { id: 'ec472a04-9712-4ebb-9c8d-981941a456e5', text: 'Zu zahlen (Zu zahlen)' },
];
